export const ACCOUNT_BLOCK_MSG = "Your account is locked please try again after 5 min";
export const PASSWORD_LENGTH_MSG = "be at least 8 characters long";
export const PASSWORD_SPECIAL_CHAR_MSG = "password_special_char";
export const PASSWORD_CHAR_MSG = "include both lower and upper case characters";
export const PASSWORD_NO_SPACE_MSG = "no_space_allowed";
export const PASSWORD_NO_MATCH_MSG = "New Password and Confirm Password did not matched";
export const NEW_PASSWORD_MSG = "Enter your new password below,we are just being extra safe.";